module.exports = __webpack_public_path__ + "img/20190726162131718.e0c37b70.png";